import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserProfileState } from './user-profile.reducer';

export const selectUserProfileState =
  createFeatureSelector<UserProfileState>('userProfile');

export const selectCurrentUserProfile = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.userProfile
);

export const selectCurrentUserProfileLoading = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.isLoading
);

export const selectCurrentUserProfileError = createSelector(
  selectUserProfileState,
  (state: UserProfileState) => state.error
);
